module.exports = __webpack_public_path__ + "static/media/gs.b7fb4660.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gs.png
// module id = 1868
// module chunks = 0